import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { RealMoment } from '../components/RealMoment';
import { SilentProblem } from '../components/SilentProblem';
import { Transformation } from '../components/Transformation';
import { ProgramModules } from '../components/ProgramModules';
import { AboutFounder } from '../components/AboutFounder';
import { Testimonials } from '../components/Testimonials';
import { TargetAudience } from '../components/TargetAudience';
import { PricingSection } from '../components/PricingSection';
import { ClosingSection } from '../components/ClosingSection';
import { Footer } from '../components/Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-black">
      <Header />
      <main>
        <Hero />
        <RealMoment />
        <SilentProblem />
        <Transformation />
        <ProgramModules />
        <AboutFounder />
        <Testimonials />
        <TargetAudience />
        <PricingSection />
        <ClosingSection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
